/**
 * Module đã cài mẫu cho cổng tenant khi chạy `?mock=` hoặc chưa đăng nhập Keycloak thật.
 *
 * `frontend_remote` trỏ vào route tệp giao diện của module-registry, mà `pnpm dev` không có: màn của
 * module hiện trạng thái lỗi nạp giao diện. Muốn thấy màn thật khi chạy dữ liệu mẫu, phục vụ bản build
 * của `modules/demo-sdk/frontend` ở đúng đường dẫn đó (README của web/admin, mục "Module đã cài").
 */
import type { InstalledModule } from '../modules/module-da-cai/types';

export function danhSachModuleDaCaiGia(): InstalledModule[] {
  return [
    {
      code: 'demo-sdk',
      name: 'Demo SDK',
      version: '0.3.0',
      frontend_remote: '/api/v1/module-assets/demo-sdk/0.3.0/remoteEntry.js',
      menus: [
        { path: '/', label: 'Tổng quan', permission: 'demo-sdk:tong-quan:read' },
        { path: '/cong-viec', label: 'Công việc', permission: 'demo-sdk:cong-viec:read' },
      ],
    },
  ];
}
